import { useState, useCallback } from "react";
import { useAuth } from "../../../components/context/LoginContext/AuthContext";

export const useCreateSchoolPayment = () => {
  const { fetchWithAuth } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createPayment = useCallback(
    async (payload) => {
      if (!payload) {
        throw new Error("Payload is required");
      }

      setLoading(true);
      setError(null);

      try {
        const formData = new FormData();

        // ✅ REQUIRED FIELDS
        formData.append("amount", payload.amount);
        formData.append("currency", payload.currency);
        formData.append("source", payload.payment_mode); // online / offline
        formData.append("method", payload.payment_method);
        formData.append("remarks", payload.remarks || "");
        formData.append("reference_id", payload.transaction_id || "");

        // ✅ OPTIONAL: proofs (array)
        if (payload.payment_proofs?.length) {
          payload.payment_proofs.forEach((file) => {
            formData.append("payment_proofs[]", file);
          });
        }

        const response = await fetchWithAuth(
          `${apiUrl}/school/payment/${payload.invoiceNumber}/capture`,
          {
            method: "POST",
            body: formData,
          }
        );

        const result = await response.json();

        if (!response.ok || !result.success) {
          throw new Error(result.message || "Failed to create payment");
        }

        return result;
      } catch (err) {
        console.error("Create Payment Error:", err);
        setError(err.message || "Something went wrong");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [apiUrl, fetchWithAuth]
  );

  return {
    createPayment,
    loading,
    error,
  };
};
